import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { LoginComponent } from "@app/auth/components/login/login.component";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import storageService from "@shared/storage/storageService";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {
  languages: any[] = [];
  selectedLanguage: any;
  DEFAULT_LANGUAGE = "fr";
  userId: any;
  data: any;
  isDeactivate: boolean;
  message: any;
  unsubscribeSurvey: string;
  surveyUnSubscribe: boolean;
  titleId: string;
  clientName: any;
  isCustNeed: string;

  constructor(
    public dialog: MatDialog,
    private broadCast: BroadCastServiceService,
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private httpService: ApiCall,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    storageService.clearAll();
    storageService.setItem("language", "fr");

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.userId = params.get("userId")?.replace(/,/g, "");
      this.titleId = params.get("titleId")?.replace(/,/g, "");
      this.isCustNeed = params.get("isCustNeed");
      this.unsubscribeSurvey = params.get("unsubscribeSurvey");
      if (this.userId && this.unsubscribeSurvey === "true") {
        this.surveyUnSubscribe = true;
        this.isDeactivate = false;
      } else if (this.userId && this.unsubscribeSurvey === "false") {
        this.getClientOrganizationDetails();
        this.isDeactivate = true;
        this.surveyUnSubscribe = false;
      }
      this.getClientOrganizationDetails();
    });
  }

  openLoginModel() {
    this.dialog.open(LoginComponent);
  }

  onButtonClick() {
    this.router.navigate(["/inquiry-form"]);
  }

  getClientOrganizationDetails() {
    if (this.userId) {
      this.httpService
        .findByClientId(this.userId)
        .subscribe((response: any) => {
          if (response.status == "SUCCESS") {
            this.data = response.data;
            this.clientName = this.data.fullName;
          }
        });
    }
  }

  userDeactivation() {
    if (this.data) {
      this.data.active = false;
      this.httpService.userDeactivate(this.data).subscribe((res: any) => {
        if (res.status == "SUCCESS") {
          this.isDeactivate = false;
          this.translate
            .get(["CHIEF_ACCOUNTANT.USERS.ADD_USER.DEACTIVATE_SUCCESS"])
            .subscribe((translation) => {
              this.message =
                translation[
                  "CHIEF_ACCOUNTANT.USERS.ADD_USER.DEACTIVATE_SUCCESS"
                ];
            });
          this.toastr.success(this.message, "", { timeOut: 3000 });
        }
      });
      this.isDeactivate = false;
    }
  }

  unsubscribeFeedbackForm() {
    if (this.userId && this.titleId) {
      const requestData = {
        userId: this.userId,
        titleId: this.titleId,
        isClientSatisfaction: this.isCustNeed,
      };

      this.httpService
        .unsubscribeTitleForm(requestData)
        .subscribe((res: any) => {
          if (res.status === "SUCCESS") {
            this.translate
              .get(["UNSUBSCRIBE_SUCCESS"])
              .subscribe((translation) => {
                this.message = translation["UNSUBSCRIBE_SUCCESS"];
              });
            this.toastr.success(this.message, "", { timeOut: 3000 });
          } else {
            this.translate
              .get(["UNSUBSCRIBE_SUCCESS"])
              .subscribe((translation) => {
                this.message = translation["UNSUBSCRIBE_SUCCESS"];
              });
            this.toastr.error(this.message, "", { timeOut: 3000 });
          }
        });
      this.surveyUnSubscribe = false;
    }
  }
}
